import React, { useEffect, useRef } from 'react'
import Btn from '../Btn/Btn'
import Loading from '../Loading/Loading'
import useRouteChat from './RouteChatHook'
import { formatIsoDateToLocale } from '../../services/util/date.service'
import './RouteChat.css'

export default function RouteChat({ fleetId, readOnly = false, title = null, style = null }) {
  const { state, localDispatch } = useRouteChat(fleetId)
  const endOfMessagesRef = useRef(null)

  useEffect(() => {
    if (endOfMessagesRef.current) endOfMessagesRef.current.scrollIntoView({ behavior: 'smooth' })
  }, [state.messages])

  if (!fleetId) return null

  const onSend = () => localDispatch.sendMessage(fleetId, state.messageText)

  return (
    <div className="route-chat" style={style || undefined}>
      <div className="route-chat__header">
        <strong>{title || `Chat da Rota - ${fleetId}`}</strong>
        <span
          className={
            state.isConnected
              ? 'route-chat__status route-chat__status--online'
              : 'route-chat__status'
          }
        >
          {state.isConnected ? 'Conectado' : 'Desconectado'}
        </span>
      </div>

      <div className="route-chat__messages">
        {state.isLoadingHistory ? (
          <div className="route-chat__loading">
            <Loading />
          </div>
        ) : state.messages.length ? (
          state.messages.map(message => (
            <div
              key={message.id}
              className={
                localDispatch.isOwnMessage(message)
                  ? 'route-chat__bubble route-chat__bubble--own'
                  : 'route-chat__bubble'
              }
            >
              <strong>{message.sender_name}:</strong> <span>{message.message}</span>
              <div className="route-chat__bubble-date">{formatChatDate(message.created_at)}</div>
            </div>
          ))
        ) : (
          <div className="route-chat__empty">Nenhuma mensagem encontrada</div>
        )}
        <div ref={endOfMessagesRef} />
      </div>

      {state.noticeMessage && <div className="route-chat__notice">{state.noticeMessage}</div>}

      {!readOnly && (
        <div className="route-chat__input">
          <input
            type="text"
            maxLength={1000}
            placeholder="Digite sua mensagem..."
            value={state.messageText}
            onChange={event => localDispatch.onChangeMessageText(event.target.value)}
            onKeyDown={event => event.key === 'Enter' && onSend()}
          />
          <Btn
            disabled={state.isSending || !state.messageText.trim()}
            isLoading={state.isSending}
            onClick={onSend}
          >
            Enviar
          </Btn>
        </div>
      )}
    </div>
  )
}

function formatChatDate(value) {
  if (!value) return ''
  try {
    return formatIsoDateToLocale(value).toFormat('dd/MM/yyyy HH:mm')
  } catch (error) {
    return ''
  }
}
